(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-home-motion"] && !Shopify.designMode) return;
  try {
    

(() => {
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  let observer;
  const selector = '.mt-sel__paso,.mt-res__card,.mt-beneficio,.mt-marca-card,.mt-sel__titulo,.mt-res__titulo,.mt-marcas__cabecera,.mt-faq .mt-h2';
  const play = (el, delay = 0, hero = false) => {
    if (media.matches || !el.animate || seen.has(el)) return;
    seen.add(el);
    const frames = hero
      ? [{ translate: '0 14px' }, { translate: '0 0' }]
      : [{ opacity: .3, translate: '0 18px' }, { opacity: 1, translate: '0 0' }];
    const animation = el.animate(frames, { duration: hero ? 650 : 550, delay, easing: 'cubic-bezier(.2,.7,.2,1)' });
    active.add(animation);
    animation.onfinish = animation.oncancel = () => active.delete(animation);
  };
  const init = () => {
    if (observer) observer.disconnect();
    const root = document.querySelector('#MainContent[data-template="index"]');
    if (!root || !root.querySelector('.mt-home-motion-marker') || media.matches) return;
    root.querySelectorAll('.mt-hero__contenido > *').forEach((el, index) => play(el, index * 65, true));
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      let index = 0;
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        play(entry.target, Math.min(index++ * 60, 180));
        observer.unobserve(entry.target);
      });
    }, { threshold: .08 });
    root.querySelectorAll(selector).forEach(el => {
      if (!seen.has(el)) observer.observe(el);
    });
  };
  media.addEventListener('change', () => {
    if (observer) observer.disconnect();
    active.forEach(animation => animation.cancel());
    if (!media.matches) init();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    if (observer) observer.disconnect();
    active.forEach(animation => animation.cancel());
    init();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


  } catch(e) { console.error(e); }
})();
})();
